import React from 'react';
import { userService } from '../../_services';
import { connect } from 'react-redux';
import { WireInfo } from './WireInfo';

class ProfilePage extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            name : '' , 
            email : '' , 
            address : '' , 
            state : '' , 
            postCode : '' , 
            country : '' , 
            mobileNumber : '' ,
            file : null ,  
            filename : 'Identity Document Image' , 
            verificationImageUrl : '' ,
            verificationStatementImageUrl : '',
            verificationStatus : '' , 
            identityNumber : '' , 
            identityType : '' , 
            memberId : 0 ,
            disableSubmit : false , 

            memberBanks : null ,   //for wireinformation
            memberProfileData : null 
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleUploadFile = this.handleUploadFile.bind(this);
    }

    handleChange(event){
        this.setState({
            [event.target.name] : event.target.value
        })
    }

    handleUploadFile (event){
        let file = event.target.files[0];

        if(file){
            this.setState ({
                filename : file.name ,
                file : file 
            });
        }

        //display image 
        let reader = new FileReader();

        reader.onload = (e) => {
            this.setState({verificationImageUrl: e.target.result});
        };
        reader.readAsDataURL(event.target.files[0]);
    }

    handleSubmit (event){
        event.preventDefault();
        
        const {dispatch} = this.props;
        const { name , email , address , state , postCode , country , mobileNumber , identityNumber , identityType , memberId , file  } = this.state; 
        
        let formBody = {
            name : name , 
            email : email ,
            address : address ,
            state : state ,
            postCode : postCode ,
            country : country ,
            mobileNumber : mobileNumber , 
            identityNumber : identityNumber , 
            identityType : identityType , 
            memberId : memberId
            
        }

        this.setState({
            disableSubmit : true
        });

        userService.update(formBody , file);
    }

    componentDidMount(){

         userService.memberProfile()
         .then(response => {
             this.setState({
                 name : response.name , 
                 email : response.email ,
                 address : response.address ,
                 state : response.state ,
                 postCode : response.postCode ,
                 country : response.country ,
                 mobileNumber : response.mobileNumber , 
                 verificationImageUrl : response.verificationImageUrl !== '' ? response.verificationImageUrl : '/images/no_uploaded.png' , 
                 verificationStatementImageUrl : response.verificationStatementImageUrl !== '' ? response.verificationStatementImageUrl : '/images/no_uploaded.png' , 
                 verificationStatus : response.verificationStatus, 
                 identityNumber : response.identityNumber , 
                 identityType : response.identityType , 
                 memberId : response.id , 
                
                 memberProfileData : response
             })
         })

         userService.getMemberBanks()
         .then(response => {
            
            if(response && Array.isArray(response)){
                this.setState({
                    memberBanks : response
                })
            }

         })
    }

    render(){
        const disableSubmit = this.state.disableSubmit ? 'disabled' : '' ;  
        const {verificationStatus} = this.state; 


        return (
            <React.Fragment>
                <section className="m-t-xs">
                    <div className="container">
                        <form onSubmit={this.handleSubmit} className="default-form is-clearfix">
                            <div className="columns">
                                <div className="column is-6 border-right p-r-lg">
                                        <h4>Update Profile</h4>

                                        <div className="field is-horizontal m-t-lg">
                                            <div className="field-label is-small">
                                                <label className="label">Email</label>
                                            </div>
                                            <div className="field-body">
                                                <input className="input" name="email" value={this.state.email} type="text" />
                                            </div>
                                        </div>

                                        <div className="field is-horizontal m-t-md">
                                            <div className="field-label is-small">
                                                <label className="label">Full Name</label>
                                            </div>
                                            <div className="field-body">
                                                <input className="input" onChange={this.handleChange} name="name" value={this.state.name} type="text" disabled={verificationStatus === true ? 'disabled' : false }/>
                                            </div>
                                        </div>

                                        <div className="field is-horizontal m-t-md">
                                            <div className="field-label is-small">
                                                <label className="label">Mobile Num.</label>
                                            </div>
                                            <div className="field-body">
                                                <input className="input" onChange={this.handleChange} name="mobileNumber" value={this.state.mobileNumber} type="tel" 
                                                    required pattern="[0-9]{0,12}" 
                                                />
                                            </div>
                                        </div>

                                        <div className="field is-horizontal m-t-md">
                                            <div className="field-label is-small">
                                                <label className="label">Address</label>
                                            </div>
                                            <div className="field-body">
                                                <input className="input" onChange={this.handleChange} name="address" value={this.state.address} type="text" />
                                            </div>
                                        </div>

                                        <div className="field is-horizontal m-t-md">
                                            <div className="field-label is-small">
                                                <label className="label">Post Code</label>
                                            </div>
                                            <div className="field-body">
                                                <input className="input" onChange={this.handleChange} name="postCode" value={this.state.postCode} type="text" />
                                            </div>
                                        </div>

                                        <div className="field is-horizontal m-t-md">
                                            <div className="field-label is-small">
                                                <label className="label">State</label>
                                            </div>
                                            <div className="field-body">
                                                <div className="select is-fullwidth">
                                                    <select value={this.state.state} name="state" onChange={this.handleChange}>
                                                        <option>Select State</option>
                                                        <option value="Not Applicable">Not Applicable</option><option value="Kedah">Kedah</option><option value="Kelantan">Kelantan</option><option value="Kuala Lumpur">Kuala Lumpur</option><option value="Labuan">Labuan</option><option value="Melaka">Melaka</option><option value="Negeri Sembilan">Negeri Sembilan</option><option value="Pahang">Pahang</option>
                                                        <option value="Perak">Perak</option><option value="Perlis">Perlis</option><option value="Pulau Pinang">Pulau Pinang</option><option value="Putrajaya">Putrajaya</option><option value="Sabah">Sabah</option><option value="Sarawak">Sarawak</option><option value="Selangor">Selangor</option><option value="Terengganu">Terengganu</option><option value="Johor">Johor</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="field is-horizontal m-t-md">
                                            <div className="field-label is-small">
                                                <label className="label">Country</label>
                                            </div>
                                            <div className="field-body">
                                                <div className="select is-fullwidth">
                                                    <select value={this.state.country} name="country" onChange={this.handleChange}>
                                                        <option>Select Country</option>
                                                        <option value="Malaysia">Malaysia</option>
                                                        <option value="Non Malaysian">Non Malaysian</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                

                                <div className="column is-6">

                                    <h4>Verification</h4>
                                    
                                    <div className="field is-horizontal m-t-md">
                                        *Provide verification details to enable Withdrawal process
                                    </div>
                                    
                                    <div className="field is-horizontal m-t-md">
                                        <div className="field-label is-small">
                                            <label className="label">Identity Type</label>
                                        </div>
                                        <div className="field-body">
                                            <div className="select is-fullwidth">
                                                <select value={this.state.identityType} name="identityType" onChange={this.handleChange} disabled={verificationStatus === true ? 'disabled' : false }>
                                                    <option >Select Identity type</option>
                                                    <option value="IC">IC</option>
                                                    <option value="Passport">Passport</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="field is-horizontal m-t-md">
                                            <div className="field-label is-small">
                                                <label className="label">Identity Number</label>
                                            </div>
                                            <div className="field-body">
                                                <input className="input" onChange={this.handleChange} name="identityNumber" value={this.state.identityNumber} type="text" disabled={verificationStatus === true ? 'disabled' : false }/>
                                            </div>
                                        </div>

                                    <div className="field is-horizontal m-t-md">
                                        <div className="field-label is-small">
                                            <label className="label">Upload Slip</label>
                                        </div>
                                        <div className="field-body">
                                            <div className="file has-name is-right">
                                                <label className="file-label">
                                                    <input onChange={this.handleUploadFile} className="file-input" type="file" name="filename" disabled={verificationStatus === true ? 'disabled' : false }/>
                                                    <span className="file-cta ">
                                                        <span className="file-icon">
                                                            <i className="fas fa-upload"></i>
                                                        </span>
                                                        <span className="file-label">
                                                            Choose a file…
                                                        </span>
                                                    </span>
                                                    <span className="file-name">
                                                        {this.state.filename}
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="field is-horizontal m-t-md">
                                        <div className="field-label is-small">
                                            <label className="label">Identity Image</label>
                                        </div>
                                        <div className="field-body">
                                            <img src={this.state.verificationImageUrl} className="holder-upload-image" name="verificationImageUrl"/>
                                        </div>
                                    </div>
                                </div>
                                    
                            </div>
                            <div className="control is-pulled-right">
                                <input type="submit" disabled={disableSubmit} className="button button-submit" value="Update Profile"/>
                            </div>
                        </form>
                    </div>
                </section>
                <WireInfo memberBanks = { this.state.memberBanks } memberId={this.state.memberId} verificationStatementImageUrl ={this.state.verificationStatementImageUrl} 
                    memberProfileData = {this.state.memberProfileData}
                />
            </React.Fragment>
        )
    }
}


function mapStateToProps(state) {
    const { user } = state;
    return {
        user
    };
}

const connected = connect(mapStateToProps)(ProfilePage);
export { connected as ProfilePage }; 



// WEBPACK FOOTER //
// ./src/Views/ProfilePage/ProfilePage.jsx